
define('text!presentation/common/actionModal/views/paymentConfirmation.html',[],function () { return '<div class="action-modal__action-content">\n    <span class="payment-confirmation--modal__action-statement" data-bind="i18n: paymentConfirmationMessage"/>\n</div>\n';});

